<template>
  <div class="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 sm12 md3>
              <v-select
                v-model="selectedMonth"
                :items="monthList"
                label="Selecione um Mês"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm12 md3>
              <v-select
                v-model="selectedYear"
                :items="yearList"
                label="Selecione um ano"
              ></v-select>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="center">
                <v-btn
                  block
                  class="mt-4 white--text"
                  color="primary"
                  @click="filter"
                >
                  Pesquisar
                </v-btn>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card>
        <v-card-title class="pa-2 vehicles">
          <span class="mx-auto font-weight-bold white--text">
            <v-icon dark>mdi-car</v-icon> - FOLLOWUP VEÍCULOS
          </span>
        </v-card-title>
        <v-data-table
          :headers="followupHeaders"
          :items="dashVehicles"
          :striped="true"
          item-key="name"
          group-key="category"
          class="elevation-1 mt-2"
          :items-per-page="15"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td :class="item.text" style=" font-weight: bold;">
                {{ item.text | formatText }}
              </td>
              <td :class="item.text">{{ item.value }}</td>
              <td :class="item.text">{{ item.perc }}</td>
              <!-- <td>{{ item.obs  }}</td> -->
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <br />
      <v-divider />

      <v-card>
        <v-card-title class="pa-2 vehicles">
          <span class="mx-auto font-weight-bold white--text">
            <v-icon dark>mdi-car-cog</v-icon> - SERVIÇOS
          </span>
        </v-card-title>
        <v-data-table
          :headers="servicesHeaders"
          :items="services"
          :striped="true"
          item-key="name"
          group-key="category"
          class="elevation-1 mt-2"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-for="(row, rowIndex) in services">
            <tr>
              <td v-for="(column, colIndex) in servicesHeaders" :key="colIndex">
                {{ row[column.value] }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <br />
      <v-divider />

      <v-card>
        <v-card-title class="pa-2 vehicles">
          <span class="mx-auto font-weight-bold white--text">
            <v-icon dark>mdi-car-off</v-icon> - SINISTROS
          </span>
        </v-card-title>
        <v-data-table
          :headers="breakdownHaders"
          :items="breakdown"
          item-class="my-item-class"
          :striped="true"
          item-key="name"
          group-key="category"
          class="elevation-1 mt-2"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
        </v-data-table>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import { Datetime } from 'vue-datetime';
import IndicatoresController from '../../controllers/IndicatoresController';
import ConfigurationController from '../../controllers/ConfigurationController';
import VehicleController from '../../controllers/VehicleController';
import ClientController from '../../controllers/ClientController';
import moment from 'moment';
import Constants from '../../models/constants/Constants';
import ActionButton from '../shared/ActionButtonsTemplate';
import TitleWithButton from '../../UIComponents/titleWithButton.vue';
import modalPadrao from '../shared/ModalPadrao.vue';

export default {
  components: {
    Datetime,
    ActionButton,
    TitleWithButton,
    modalPadrao,
  },
  data() {
    return {
      indicatoresController: new IndicatoresController(this.$resource),
      configurationController: new ConfigurationController(this.$resource),
      vehicleController: new VehicleController(this.$resource),
      clientController: new ClientController(this.$resource),
      clienteId: localStorage.getItem('client_id'),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      carServiceData: [],
      clients: [],
      typeCharge: [],
      selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,
      yearList: [],
      monthList: [],
      vehicles: [],
      breakdownType: [],
      situation: true,
      searchPlate: null, //id do veículo
      searchClients: null,
      searchBreakdownType: null, //id do condomínio
      maintenance: {
        vehicle_id: '',
        client_id: '',
        breakdown_type_id: '',
        date_breakdown: '',
        status: false,
        repair_completion: '',
      },
      filterDefault: {
        ano: new Date().getFullYear(),
        mes: new Date().getMonth() + 1,
      },
      services: [],
      breakdown: [],
      dashVehicles: [],
      servicesHeaders: [
        { text: 'Descrição', value: 'description', class: 'bg-column' },
      ],
      breakdownHaders: [
        { text: 'Descrição', value: 'description', class: 'bg-column' },
      ],
      followupHeaders: [
        { text: 'Descrição', value: 'description', class: 'bg-column' },
        { text: 'Quantidade', value: 'qtd' },
        { text: '%', value: 'percent' },
        // { text: 'Observação', value: 'obs' },
      ],
      maintenance_type_modal: false,
      modalConfirmacao: {
        open: false,
        title: '',
        action: '',
      },
      properties: {
        'prepend-icon': 'mdi-currency-brl',
      },
      options: {
        locale: 'pt-BR',
        length: 8,
        precision: 2,
      },
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
    };
  },
  async created() {
    this.loadData();
    this.getAllDashVehicles().then(res => {
      this.getAllBreakdown(this.filterDefault);
      this.getServices(this.filterDefault);
    });
    this.getVehicles();
    this.monthList = this.getMonthsOfYear();
    for (let year = this.selectedYear; year >= 1900; year--) {
      this.yearList.push(year);
    }
  },
  methods: {
    changeService(item, action) {
      this.actionItem = item;
      this.action = action;
      this.modalConfirmacao.title = 'Deseja excluir o registro de Sinistro?';
      this.modalConfirmacao.action = action;
      this.modalConfirmacao.open = true;
    },

    async actionModalConfirmacao() {
      switch (this.action) {
        case 'finish':
          return this.finishMaintenance();
        case 'delete':
          return this.deleteService();
      }
    },
    getMonthsOfYear() {
      const months = [];
      const date = new Date();
      const currentYear = date.getFullYear();

      for (let i = 0; i < 12; i++) {
        const monthName = new Date(currentYear, i).toLocaleString('pt-BR', {
          month: 'long',
        });
        months.push({ text: monthName.toUpperCase(), value: i + 1 });
      }

      return months;
    },
    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },
    async loadData({ withFilters = false } = {}) {
      this.carServiceData = [];
      this.blockScreen = true;

      this.indicatoresController
        .getAllIndicators({
          ano: this.selectedYear,
          mes: this.selectedMonth,
        })
        .then(
          response => {
            this.carServiceData = this.trataIndicadores(response.body);
          },
          err => console.log(err)
        );

      this.blockScreen = false;
    },
    trataIndicadores(data) {
      this.services = [];
      this.servicesHeaders = [{ text: 'Descrição', value: 'description' }];
      this.breakdown = [];
      this.breakdownHaders = [{ text: 'Descrição', value: 'description' }];
      data.forEach(element => {
        if (element.follow_up == 'SERVICES') {
          if (
            !this.services.some(
              objeto => objeto['description'] === element.description
            )
          ) {
            let service = {};
            service['description'] = element.description;
            service[`DT_${element.data.replace('/', '_')}`] = element.count;
            this.services.push(service);
          } else {
            const service = this.services.find(
              obj => obj.description === element.description
            );
            service[`DT_${element.data.replace('/', '_')}`] = element.count;
          }
          if (
            !this.servicesHeaders.some(
              objeto =>
                objeto['value'] === `DT_${element.data.replace('/', '_')}`
            )
          )
            this.servicesHeaders.push({
              text: 'Mês ' + element.data,
              value: `DT_${element.data.replace('/', '_')}`,
            });
        } else {
          if (
            !this.breakdown.some(
              objeto => objeto['description'] === element.description
            )
          ) {
            let bk = {};
            bk['description'] = element.description;
            bk[`DT_${element.data.replace('/', '_')}`] = element.count;
            this.breakdown.push(bk);
          } else {
            const bk = this.breakdown.find(
              obj => obj.description === element.description
            );
            bk[`DT_${element.data.replace('/', '_')}`] = element.count;
          }
          if (
            !this.breakdownHaders.some(
              objeto =>
                objeto['value'] === `DT_${element.data.replace('/', '_')}`
            )
          )
            this.breakdownHaders.push({
              text: 'Mês ' + element.data,
              value: `DT_${element.data.replace('/', '_')}`,
            });
        }
      });
      return data;
    },
    filter() {
      this.loadData({
        withFilters: true,
      }).then(res => {
        this.getAllBreakdown({
          ano: this.selectedYear,
          mes: this.selectedMonth,
        });
        this.getServices({ ano: this.selectedYear, mes: this.selectedMonth });
      });

      this.searchPlate = null;
      this.searchBreakdownType = null;
    },
    async getVehicles() {
      await this.vehicleController.getAllVehicles().then(
        vehicles => {
          vehicles.forEach(element => {
            this.vehicles.push({
              id: element.id,
              value: { id: element.id, valor: element.vehicle_model.model },
              text: element.vehicle_model.model,
              name: `${element.vehicle_model.model} - ${element.plate}`,
              client_id: element.client.id,
            });
          });
        },
        err => console.log(err)
      );
    },
    async getAllDashVehicles() {
      await this.indicatoresController.getAllDashVehicles().then(
        dashVehicles => {
          let total;
          let perc;
          Object.entries(dashVehicles.body[0]).forEach(([key, value]) => {
            if (key == 'total') {
              total = value;
            }
            perc = (value * 100) / total;
            this.dashVehicles.push({
              text: key,
              value: value,
              perc: perc.toString().substring(0, 5) + '%',
              obs: '',
            });
          });
        },
        err => console.log(err)
      );
    },
    async getAllBreakdown(filter) {
      await this.indicatoresController.getAllBreakdown(filter).then(
        breakdown => {
          breakdown.body.forEach(element => {
            //insere no array de breakdown os valores agrupados por dia
            let obj = this.breakdown.find(
              item => item.description === element.description
            );
            this.breakdown[this.breakdown.indexOf(obj)] = Object.assign(
              {},
              obj,
              element
            );

            //insere no header de breakdown os valores agrupados por dia
            for (let chave in element) {
              if (
                !this.breakdownHaders.some(objeto => objeto['value'] === chave)
              )
                this.breakdownHaders.push({
                  text: `Dia ${chave
                    .replace('_', '/')
                    .replace('_', '/')
                    .replace('m', '')
                    .replace('/' + this.selectedYear, '')}`,
                  value: chave,
                });
            }
          });
        },
        err => console.log(err)
      );
    },
    async getServices(filter) {
      await this.indicatoresController.getServices(filter).then(
        services => {
          services.body.forEach(element => {
            //insere no array de services os valores agrupados por dia
            let obj = this.services.find(
              item => item.description === element.description
            );
            this.services[this.services.indexOf(obj)] = Object.assign(
              {},
              obj,
              element
            );

            //insere no header de services os valores agrupados por dia
            for (let chave in element) {
              if (
                !this.servicesHeaders.some(objeto => objeto['value'] === chave)
              )
                this.servicesHeaders.push({
                  text: `Dia ${chave
                    .replace('_', '/')
                    .replace('_', '/')
                    .replace('m', '')
                    .replace('/' + this.selectedYear, '')}`,
                  value: chave,
                });
            }
          });
        },
        err => console.log(err)
      );
    },
  },
  computed: {
    listVehicles() {
      return this.vehicles;
    },
  },
  filters: {
    formatText(vl) {
      return vl.toUpperCase().replace('_', ' ');
    },
  },
};
</script>

<style scoped>
.inputs >>> #inputDate {
  width: 100%;
  text-align: center;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}
.colorSelectedBack {
  background-color: var(--secondary-color);
}
.sizeTop {
  height: 48px;
}

hr {
  width: 2px;
  height: 25px;
  margin: auto 0;
}

.button {
  margin: 0 auto;
}

.button-text {
  text-transform: none;
}

.second {
  margin-bottom: 46px;
}

.sizePart {
  width: 49%;
  text-align: center;
}

.cardBottom {
  position: absolute;
  bottom: 56px;
  border-radius: 0;
}

.cardRadius {
  border-radius: 4px;
}

.carSelected {
  border: 2px solid var(--secondary-color) !important;
}

.cardTitle {
  font-size: 18px;
}

.cardContent {
  display: flex;
  justify-content: space-between;
}

.creditCard {
  display: inline-flex;
}

.coupon {
  display: flex;
}

.couponBtn {
  outline: none;
}

.vehicle {
  display: flex;
}

.modelo {
  font-size: 16px;
  color: #181f4d;
}

.caption {
  color: #181f4d;
}

.contentLeft {
  display: inline-block;
  width: 60%;
}

.contentRight {
  display: inline-block;
  width: 40%;
}

.vehicleImg {
  margin-left: -10px;
}
.autocomplete__inputs input {
  height: 44px !important;
}
.vdatetime {
  width: 100%;
}

.inputs {
  border: 1px solid rgb(173, 173, 173);
  border-radius: 6px;
  align-content: middle;
  width: 90%;
  margin: 0 auto;
  display: flex;
}

.border {
  border: 2px solid grey;
}

.borderBottom {
  border-bottom: 1px solid gray;
}

.bottom {
  margin-bottom: 60px;
}

.fab {
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 0 0;
  display: flex;
}

.floatBtn {
  position: absolute;
  bottom: 56px;
  width: 100%;
  margin: 0 auto;
}

.colorBtn {
  background-color: var(--primary-color) !important;
}

.checkin {
  background-color: var(--secondary-color);
}

.checkin-text {
  color: var(--secondary-color);
}

.checkinBorder {
  border: 1px solid var(--secondary-color) !important;
}

.checkout {
  background-color: var(--orange-color) !important;
}

.checkout-text {
  color: var(--orange-color);
}

.checkoutBorder {
  border: 1px solid var(--orange-color) !important;
}

.total {
  color: #181f4d;
}

.sfalse {
  color: red;
}

.strue {
  color: green;
}

.vehicles {
  background-color: var(--primary-color);
}

.bg-column {
  background-color: #2f5293 !important;
}

.ociosidade {
  color: red;
}

.estoque_sp,
.estoque_mg {
  background-color: yellow !important;
}

th {
  font-weight: bold;
}

.veiculos_internos {
  background-color: gray !important;
}

.bg-blue {
  background-color: blue;
  color: white;
}

.my-item-class > td {
  text-align: center;
  background-color: yellow !important;
}
</style>
